const TEXT = {
    ADDRESS_CONTENT_TEXT_1:"管理收货地址",
    ADDRESS_CONTENT_TEXT_2:"默认地址",
    ADDRESS_CONTENT_TEXT_3:"设为默认",
    ADDRESS_CONTENT_TEXT_4:"删除",
    ADDRESS_CONTENT_TEXT_5:"编辑",
    ADDRESS_CONTENT_TEXT_6:"添加新地址",
    ADDRESS_CONTENT_TEXT_7:"添加收货地址",
    ADDRESS_CONTENT_TEXT_8:"收货人",
    ADDRESS_CONTENT_TEXT_9:"请填写收货人姓名",
    ADDRESS_CONTENT_TEXT_10:"联系电话",
    ADDRESS_CONTENT_TEXT_11:"请填写收货人联系电话",
    ADDRESS_CONTENT_TEXT_12:"所在地区",
    ADDRESS_CONTENT_TEXT_13:"请选择所在地区",
    ADDRESS_CONTENT_TEXT_14:"详细地址",
    ADDRESS_CONTENT_TEXT_15:"确认",
    ADDRESS_CONTENT_TEXT_16:"修改收货地址",
    ADDRESS_CONTENT_TEXT_17:"选择收货地址",
    ADDRESS_CONTENT_TEXT_18:" 暂无地址",
};
export {
	TEXT
}


// WEBPACK FOOTER //
// ./src/config/page/cn/address/index.js